/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { apiClient } from './api'
import { handleError } from './error';
import { UniversalTrackerPlain } from '../types/universalTracker';
import { RootState } from '../reducers';
import { DefaultBlueprintCode } from '@features/survey-configuration/types';

export const loadBlueprintMapping = (code: string = DefaultBlueprintCode) => (dispatch: any, getState: any) => {

  if (getState().blueprint.code === code || !code) {
    return;
  }

  dispatch({ code, type: actionTypes.LOADING_BLUEPRINT });

  apiClient.get(`/blueprints/${code}`)
    .then(response => {
      dispatch({
        type: actionTypes.LOADED_BLUEPRINT,
        data: response.data.data,
      });
    })
    .catch(handleError(dispatch, actionTypes.ERROR_BLUEPRINT))
};

export const loadInitiativeQuestions = (initiativeId: string, blueprint = DefaultBlueprintCode) => {
  return (dispatch: any, getState: () => RootState) => {
    const state = getState().initiativeBlueprintQuestions;
    if (state.initiativeId === initiativeId) {
      return;
    }
    dispatch(reloadInitiativeQuestions(initiativeId, blueprint, true));
  }
}

export const reloadInitiativeQuestions = (initiativeId: string, blueprint = DefaultBlueprintCode, blockingLoad = false) => {
  return (dispatch: any, _getState: () => RootState) => {
    if (blockingLoad) {
      dispatch({
        type: actionTypes.LOADING_INITIATIVE_BLUEPRINT_QUESTIONS,
        initiativeId: initiativeId
      });
    }

    return apiClient.get(`initiatives/${initiativeId}/blueprint/${blueprint}/questions`)
      .then((response) => {
        dispatch({
          type: actionTypes.LOADED_INITIATIVE_BLUEPRINT_QUESTIONS,
          data: response.data.data.sort((a: UniversalTrackerPlain, b: UniversalTrackerPlain) => a.name.localeCompare(b.name)),
          initiativeId: initiativeId
        });
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          return dispatch({
            type: actionTypes.ERROR_INITIATIVE_BLUEPRINT_QUESTIONS,
            data: undefined,
            initiativeId: initiativeId
          });
        }
        handleError(dispatch, actionTypes.ERROR_INITIATIVE_BLUEPRINT_QUESTIONS)(error);
      })
  }
}
